<template>
  <div>
    <v-autocomplete
      outlined
      v-if="readonly === false"
      dense
      v-model="select"
      :items="lista"
      item-text="descripcion_nacionalidad"
      item-value="id_nacionalidad"
      label="Nacionalidad"
      persistent-hint
      return-object
      @change="$emit('input', select.id_nacionalidad)"
      hide-details
    ></v-autocomplete>
    <v-text-field
      hide-details
      dense
      label="Nacionalidad"
      v-if="readonly === true"
      readonly
      filled
      outlined
      :value="select.descripcion_nacionalidad"
    ></v-text-field>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: {
    value: Number,
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {
      select: {
        id_nacionalidad: 0,
        descripcion_nacionalidad: "",
      },
    };
  },
  computed: {
    ...mapState("nacionalidades", ["Lista"]),
    lista: function() {
      let l = [...this.Lista];
      l = l.filter(function(obj) {
        return obj.id_nacionalidad != 10;
      });
      let l2 = []
      l2.push({
        id_nacionalidad: 0,
        descripcion_nacionalidad: " --Seleccione-- ",
      });
      l2.push({
        id_nacionalidad: 10,
        descripcion_nacionalidad: "ARGENTINA",
      });
      l2 = [...l2, ...l]
      return l2;
    },
  },
  methods: {
    ...mapActions("nacionalidades", ["set"]),
    seleccionar(id) {
      if (id) {
        let pr = this.lista.find((x) => x.id_nacionalidad == id);
        if (pr) {
          this.select = pr;
        } else {
          this.seleccionar("0");
        }
      }
    },
  },
  async mounted() {
    let id = this.value;
    this.seleccionar(id);
  },
  watch: {
    value: function(newVal, oldVal) {
      this.seleccionar(newVal);
    },
  },
};
</script>

<style></style>
